import DOMPurify from "dompurify";

/** Contract allow-list — mirrors producer nh3 tags. */
export const ORG_DISCLAIMER_ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
] as const;

const HTML_TAG_RE = /<\/?[A-Za-z][^>]*>/;

export function looksLikeOrgDisclaimerHtml(value: string): boolean {
  return HTML_TAG_RE.test(value);
}

/**
 * Defence-in-depth sanitise before DOM injection.
 * Legacy plain text (no tags) is returned unchanged — no wrapping.
 */
export function sanitiseOrgDisclaimerHtml(raw: string): string {
  if (!looksLikeOrgDisclaimerHtml(raw)) {
    return raw;
  }
  return DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: [...ORG_DISCLAIMER_ALLOWED_TAGS],
    ALLOWED_ATTR: [],
  });
}
